import type { Meld } from "@kikik/mahjong-core";
import { useI18n } from "../i18n";
import { MahjongTile, TileBack } from "./tiles";
import type { TileSize } from "./tiles";

export function MeldRow({ melds, size = "sm" }: { melds: readonly Meld[]; size?: TileSize }) {
  const { t, meld: meldName } = useI18n();
  if (melds.length === 0) return null;
  return (
    <div className="melds" role="list" aria-label={t("seat.melds")}>
      {melds.map((meld, index) => (
        <span className="melds__group" role="listitem" key={index} title={meldName(meld.kind)}>
          {meld.tiles.map((tile, position) =>
            // A concealed kong shows only its outer tiles face up.
            meld.concealed && meld.kind === "kong" && position > 0 && position < 3 ? (
              <TileBack key={tile.id} size={size} />
            ) : (
              <MahjongTile key={tile.id} kind={tile.kind} size={size} />
            ),
          )}
        </span>
      ))}
    </div>
  );
}
